import Layout from '@/AppMain.vue';

const promotions= {
    path: '/stores',
    name: 'Stores',
    component: Layout,
    children:[
        {
            path: '/stores',
            name: 'Stores',
            component: () => import('@/views/stores/browse'),
            meta: {title: 'Stores', auth: true, name: 'Stores', back:'/', middlewares:['activeWebsite','admin']},
        },
    ]
};
export default promotions;
